module.exports = __webpack_public_path__ + "static/approve-event-41b0f66f29c4def3a27952fb31661451.mp4";